import React, { useEffect, useState } from 'react';
import CuadroPaises from './CuadroPaises.js';
import CuadroTorneosPais from './pais/CuadroTorneosPais.js';
import HomeTorneosLayout from './HomeTorneosLayout.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './HomeTorneosPaises.module.css';

const HomeTorneosPaises = (props) => {
  const [principales, setPrincipales] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    fetchData('paises?principales=true', setPrincipales);
  }, [fetchData]);

  return (
    <HomeTorneosLayout variant="twoColumnSidebar">
      <div className={`${styles.columnaPrincipal}`}>
        <div className={`${styles.contenedorCuadros}`}>
          {principales &&
            principales.map((pais, index) => <CuadroTorneosPais key={index} pais={pais} />)}
        </div>
        <MensajeCargando isCargando={isCargando} />
        <MensajeError errores={erroresGetLista} />
      </div>
      <div className={`${styles.columnaLateral}`}>
        <CuadroPaises
          titulo="Torneos nacionales"
          incluirPrincipales={false}
          pathLinks="/torneosPais/"
        />
      </div>
    </HomeTorneosLayout>
  );
};

export default HomeTorneosPaises;
